import { render, staticRenderFns } from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=template&id=e1104498&scoped=true"
import script from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=script&lang=js"
export * from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=script&lang=js"
import style0 from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=style&index=0&id=e1104498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1104498",
  null
  
)

export default component.exports